
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { changeState, logout, mudarMensagens, mudarProcesso } from '../actions/AppActions';
import { connect } from 'react-redux';

import moment from 'moment-timezone';
import { decrypt, URL } from '../variables';
import Chat from './Chat';
import { formatDuration, ServerClock } from './serverClock';
import { getLanguageTexts, getSelectedLanguage } from '../language';
import { CandidateValidationNotice } from './CandidateUi';

class NaoIniciada extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            redirect: false,
            path: '/',
            time_text: '88:88:88',
            chat_show: false,
            show_btn_line: false,
            loading_line: false,
            position: -1,
            position_interview: -1,
            show_fila: false,
            show_fila_interview: false,
            loading_line_interview: false,
            show_btn_line_interview: false,
        };
        this.last_date = moment().format('YYYY-MM-DD HH:mm:ss');
        this.unmont_ = false;
        this.iniciado = false;
        this.serverClock = new ServerClock();
    }

    incTimer() {

        if (!this.serverClock.isReady()) {
            this.timer_timeout = setTimeout(
                this.incTimer.bind(this),
                1000
            );
            return;
        }

        let totalSecs = this.serverClock.secondsUntil(this.props.processo.inicio);
        const formattedTime = formatDuration(totalSecs);

        if (document.getElementById('timer') == null) {
            return;
        }

        document.getElementById('timer').innerHTML =
            formattedTime;

        if (
            totalSecs <= this.props.processo.chat_time &&
            this.state.chat_show == false
        ) {
            this.setState({ chat_show: true });
        }

        if (totalSecs <= 0) {

            totalSecs = 0;
            this.iniciado = true;

            this.setState({
                time_text: "00:00:00"
            });

            if (this.props.processo.simulado == false) {
                this.props.goToRules();
            }
            else {
                this.setState({ show_btn_line: true });
            }

            return;
        }

        this.setState({
            time_text: formattedTime
        });

        this.timer_timeout = setTimeout(
            this.incTimer.bind(this),
            1000
        );
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }





    componentDidUpdate(props) {
        if (props.connect != this.props.connect && this.props.connect == false) {
            if (this.props.processo.interview == true) {
                this.setState({
                    show_btn_line: false,
                    loading_line: false,
                    position: -1,
                    position_interview: -1,
                    show_fila: false,
                    show_fila_interview: false,
                    loading_line_interview: false,
                    show_btn_line_interview: true,
                })
            }
        }

        if (this.props.tempo_atual != null && this.props.tempo_atual != props.tempo_atual) {
            this.serverClock.sync(this.props.tempo_atual);
        }
    }

    componentDidMount() {
        this.serverClock.sync(this.props.tempo_atual);
        this.incTimer();
        if (this.props.processo.simulado == false) {
            this.logs_timeout = setTimeout(() => {
                this.salvar_log();
            }, this.props.processo.save_timer_pre_exam);

            if (this.props.processo.interview == true) {
                this.setState({ show_btn_line_interview: true });

                this.props.socket.on('line_check_interview', function (data) {
                    console.log('line check interview', data)

                    if (data.status == 'enter_now') {
                        // this.props.goToRules('?enter_now=1');
                    }
                    else if (data.status == 'line_wait') {
                        this.setState({ position_interview: data.position + 1, show_fila_interview: true });
                    }

                }.bind(this));
            }
            if (this.props.socket != null && this.props.user.accessibility && this.props.user.type_supervisor != 'none' && this.props.processo.is_interview == false) {
                console.log('montou', this.props.user)
                this.props.changeState({ show_call: true });
            }
        }
        else {
            if (this.props.socket != null) {

                this.props.socket.on('line_check', function (data) {
                    clearTimeout(this.timerLine);
                    console.log('line check', data)
                    if (data.status == 'enter_now') {
                        this.props.goToRules('?enter_now=1');
                    }
                    else if (data.status == 'line_wait') {
                        this.setState({ position: data.position + 1, show_fila: true });
                    }
                    // setTimeout(()=>{
                    //     if(this.unmont!=true){
                    //         this.socket.connect();
                    //     }
                    // },2000);
                }.bind(this));



                // setTimeout(()=>{
                //     if(this.unmont!=true){
                //         this.socket.connect();
                //     }
                // },2000);
            }
        }


        this.timer_get_time = setTimeout(() => {
            this.get_time_server();
        }, 30000);
    }



    get_time_server() {
        if (this.iniciado == true) {
            return;
        }

        fetch(`${URL}api/get_time_server?v=a`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                else {
                    if (resp.atual != null) {
                        this.serverClock.sync(resp.atual);
                    }
                }
                this.timer_get_time = setTimeout(() => {
                    this.get_time_server();
                }, 30000);
            } catch (err) {
                console.log(err);
                this.timer_get_time = setTimeout(() => {
                    this.get_time_server();
                }, 30000);
            }

        })
            .catch((err) => {
                console.log(err);
                this.timer_get_time = setTimeout(() => {
                    this.get_time_server();
                }, 30000);
            });
    }

    componentWillUnmount() {
        clearTimeout(this.logs_timeout);
        clearTimeout(this.timer_timeout);
        this.unmont_ = true;
        clearTimeout(this.timer_get_time);
        if (this.props.processo.simulado == true && this.props.socket != null) {
            this.props.socket.off('line_check');
            this.props.socket.off('line_check_interview');

        }
        clearTimeout(this.timerLine);
        clearInterval(this.lineCheckInterval)
        clearInterval(this.lineCheckInterviewInterval);


    }

    salvar_log() {
        fetch(`${URL}api/salvar_log?v=a&screen=not_initial&processo_id=${this.props.processo.id}&processo_name=${this.props.processo.name}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    this.serverClock.sync(resp.atual);
                    this.clientNow = moment();
                    if (resp.status == false) {
                        this.props.get_processo();
                    }
                    else {
                        if (resp.processo != null && resp.processo.updated_at != this.props.processo.updated_at) {
                            this.props.mudarProcesso(resp.processo);
                        }
                        if (this.unmont_ == false) {

                            this.logs_timeout = setTimeout(() => {
                                this.salvar_log();
                            }, this.props.processo.save_timer_pre_exam);
                        }
                    }
                }
            } catch (err) {
                console.log(err);
                if (this.unmont_ == false) {

                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, this.props.processo.save_timer_pre_exam);
                }
            }

        })
            .catch((err) => {
                console.log(err);
                if (this.unmont_ == false) {

                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, this.props.processo.save_timer_pre_exam);
                }
            });
    }



    render() {
        const t = getLanguageTexts(getSelectedLanguage());

        return (
            <div className="candidate-state candidate-waiting">

                <hr />
                {this.state.loading_line != true && this.state.show_btn_line == false && this.state.show_fila == false && <div>
                    <p className="candidate-section-kicker">{t.scheduled_evaluation}</p>
                    <h3 className="candidate-section-title">{t.evaluation_not_started}</h3>
                    <p className="candidate-section-description">{t.starts_in}</p>
                </div>}
                {this.state.show_btn_line == false && this.state.show_fila == false && <div id='timer' className="candidate-countdown">

                </div>}


                {this.state.show_fila_interview == true && <div>
                    <p style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>{t.waiting_interview_queue}</p>
                    {this.state.position_interview != -1 && <div style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}><div style={{ borderWidth: 3, height: 20, width: 20 }} className="spinner-border text-info" role="status"  >
                    </div> {t.queue_position}: {this.state.position_interview}</div>}
                    {/* <p style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>O tempo de prova iniciará após o acesso. Tempo de prova após iniciar: {this.props.processo.tempo_prova + ' min'}</p> */}
                </div>}
                {this.state.show_fila_interview == false && this.state.loading_line_interview == true && <div>
                    <p style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>{t.entering_interview_queue}</p>
                </div>}

                {this.props.connect == true && this.state.show_btn_line_interview == true && this.state.loading_line_interview == false && <div className="row">
                    <div className="col-12 d-flex justify-content-center align-items-center">
                        <button type="button" id="accept" onClick={(e) => {
                            this.setState({ loading_line_interview: true, show_btn_line_interview: false });
                            // this.timerLine = setTimeout(() => {
                            //     this.setState({ loading_line: false, show_btn_line: true });
                            // }, 10000);

                            // this.setState({ loading_line: true });

                            this.props.socket.emit("line_check_interview", { aluno_id: this.props.user.id, faculdade_id: this.props.faculdade.id, sala_id: this.props.sala.id });
                            clearInterval(this.lineCheckInterviewInterval);
                            this.lineCheckInterval = setInterval(() => {
                                if (this.props.socket != null) {
                                    this.props.socket.emit("line_check_interview", { aluno_id: this.props.user.id, faculdade_id: this.props.faculdade.id, sala_id: this.props.sala.id });
                                }
                            }, 30000);
                            //enviar evento pro line_check e colocar interval de a cada 60 segundos verificar no line_check.

                        }} className="btn btn-info btn-lg waves-effect waves-light mt-2"
                            style={{}}><i className='mdi mdi-call-received'></i> {t.join_interview_queue}</button>
                    </div>
                </div>}

                {this.state.show_fila == true && <div>
                    <p style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>{t.waiting_queue}</p>
                    {this.state.position != -1 && <div style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}><div style={{ borderWidth: 3, height: 20, width: 20 }} className="spinner-border text-primary" role="status"  >
                    </div> {t.queue_position}: {this.state.position}</div>}
                    <p style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>{t.exam_time_after_access.replace('{minutes}', this.props.processo.tempo_prova)}</p>

                </div>}
                {this.state.show_fila == false && this.state.loading_line == true && <div>
                    <p style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>{t.entering_queue}</p>
                </div>}
                {this.props.processo.simulado == false && this.state.chat_show == true && this.props.processo_resultado?.status != 'F' && (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && this.props.processo.chat_type != 'none' && <Chat
                    send_message={(m) => this.props.send_message(m)}

                />}
                {this.props.connect == true && this.state.show_btn_line == true && this.state.loading_line == false && <div className="row">
                    <div className="col-12">
                        <button type="button" id="accept" onClick={(e) => {
                            this.setState({ loading_line: true, show_btn_line: false });
                            // this.timerLine = setTimeout(() => {
                            //     this.setState({ loading_line: false, show_btn_line: true });
                            // }, 10000);

                            // this.setState({ loading_line: true });

                            this.props.socket.emit("line_check", { aluno_id: this.props.user.id, faculdade_id: this.props.faculdade.id });
                            clearInterval(this.lineCheckInterval);
                            this.lineCheckInterval = setInterval(() => {
                                if (this.props.socket != null) {
                                    this.props.socket.emit("line_check", { aluno_id: this.props.user.id, faculdade_id: this.props.faculdade.id });
                                }
                            }, 30000);
                            //enviar evento pro line_check e colocar interval de a cada 60 segundos verificar no line_check.

                        }} className="btn btn-success btn-lg waves-effect waves-light"
                            style={{ width: '100%' }}>{t.join_interview_queue_short}</button>
                    </div>
                </div>}
                {this.props.connect == false && this.props.socket != null && <CandidateValidationNotice tone="warning" title={t.unstable_connection}>{t.unstable_connection}</CandidateValidationNotice>}
                {this.state.loading_line == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    <div className="spinner-border text-primary" role="status"  >
                    </div>
                </div></div>}
            </div>

        );
    }
}
const mapsStateToProps = (state) => (
    {
        tempo_atual: state.AppReducer.tempo_atual,
        processo: state.AppReducer.processo,
        processo_resultado: state.AppReducer.processo_resultado,
        faculdade: state.AppReducer.faculdade,
        token: state.AppReducer.token,
        socket: state.AppReducer.socket,
        sala: state.AppReducer.sala,
        connect: state.AppReducer.connect,
        user: state.AppReducer.user,
        mensagens: state.AppReducer.mensagens,
        candidate_inside_screen: state.AppReducer.candidate_inside_screen,

    }
);

export default withRouter(connect(mapsStateToProps, { logout, mudarProcesso, mudarMensagens, changeState })(NaoIniciada));
